<template>
    <!-- everything should be wrapped by one item for some reason -->
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_two_phase_method_setting'"></div>
        </div>
        <div class="object-inner-table" style="margin-top: 10%;">
            <div class="default-message">
                <span v-html="$t('message.info_two_phase_method_guide1')"></span><br><br>
                <span v-html="$t('message.info_two_phase_method_guide2')"></span><br><br>
                <span v-html="$t('message.info_two_phase_method_guide3')"></span><br><br>
                <br><br>
                <div v-if="twoPhaseMethod && appData.tenantAdminUser">
                    <span v-html="$t('message.info_two_phase_method_code1')"></span><br>
                    <button class="transparent-button" type="button" v-on:click="showTwoPhaseMethodTenantTOTP=true"><span class="code-guide-text" v-t="'message.info_two_phase_method_code2'"></span></button>
                    <br><br>
                </div>
                <br><br>
            </div>
            <div class="object-titlebox">
                <div class="object-titlebox-right">
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck()"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                </div>
            </div>
            <table width=100%>
                <tr class="objectitem-record"><td width=40% class="object-item" v-t="'message.item_two_phase_method_app'"></td><td width=40% class="object-value">{{ getTwoPhaseMethodText(twoPhaseMethod) }}</td></tr>
                <tr class="objectitem-record">
                    <td width=40% class="object-item" v-t="'message.item_two_phase_method_console'"></td>
                    <td width=40% class="object-value">{{ getTwoPhaseMethodText(twoPhaseMethodConsole) }}</td>
                    <td class="object-item">
                        <button v-if="twoPhaseMethodConsole" class="transparent-button" type="button" v-on:click="showSearchUserDialogAfterWritableCheck()">
                            <img src="../../../../assets/loupe.svg"/>
                            <span class="normal-command-text" v-t="'message.title_two_phase_auth_user_search'"></span>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
        <twoPhaseMethodSearch v-if="showSearchTwoPhaseMethodUser"
            @cancel="showSearchTwoPhaseMethodUser=false"
        />
        <twoPhaseMethodTenantEdit v-if="showTwoPhaseMethodTenantEdit"
            ref="TwoPhaseMethodTenantEdit"
            :appData="appData"
            @saveApp="setTwoPhaseMethod"
            @saveConsole="setTwoPhaseMethodConsole"
            @saveBoth="setTwoPhaseMethodBoth"
            @cancel="showTwoPhaseMethodTenantEdit=false">
        </twoPhaseMethodTenantEdit>
        <twoPhaseMethodTenantTOTP v-if="showTwoPhaseMethodTenantTOTP" ref="TwoPhaseMethodTenantTOTP" :appData="appData" @cancel="showTwoPhaseMethodTenantTOTP=false"></twoPhaseMethodTenantTOTP>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import TwoPhaseMethodTenantEdit from '@/components/pc/setting/twophasemethod/TwoPhaseMethodSettingEdit.vue';
import TwoPhaseMethodTenantTOTP from '@/components/pc/setting/twophasemethod/TwoPhaseMethodSettingTOTP.vue';
import TwoPhaseMethodSearch from '@/components/pc/setting/twophasemethod/TwoPhaseMethodSearch.vue';

export default {
    data() {
        return {
            twoPhaseMethod: false,
            twoPhaseMethodConsole: false,
            showTwoPhaseMethodTenantEdit: false,
            showTwoPhaseMethodTenantTOTP: false,
            showSearchTwoPhaseMethodUser: false,
            dialogTitle: ""
        };
    },
    methods: {
        getTwoPhaseMethodText(twoPhaseMethod) {
            if (twoPhaseMethod) {
                return commonUtil.getMessageText(this.$i18n, "item_value_used");
            } else {
                return commonUtil.getMessageText(this.$i18n, "item_value_nonUsed");
            }
        },
        showDialogAfterWritableCheck() {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_edit_tenant_two_phase_method"));
                return;
            }
            this.showTwoPhaseMethodTenantEdit = true;
        },
        showSearchUserDialogAfterWritableCheck() {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_edit_tenant_two_phase_method"));
                return;
            }
            this.showSearchTwoPhaseMethodUser = true;
        },
        setTwoPhaseMethod(modifyTenantOptionRequest) {
            const newFlag = modifyTenantOptionRequest.twoPhaseMethod;
            let self = this;
            server.post('/modifytenantoption', modifyTenantOptionRequest)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_two_phase_method_edited"));
                            self.twoPhaseMethod = newFlag;
                            self.appData.twoPhaseMethod = newFlag;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","setTwoPhaseMethod").replace("{code}",res.data.status));
                            break;
                    }
                    self.showTwoPhaseMethodTenantEdit = false;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "setTwoPhaseMethod", error);
                    self.showTwoPhaseMethodTenantEdit = false;
                });
        },
        setTwoPhaseMethodConsole(modifyTenantOptionRequest) {
            const enable = modifyTenantOptionRequest.twoPhaseMethodConsole;
            let self = this;
            server.post('/modifyconsoleenabletwophasemethod', {enable: enable})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_two_phase_method_edited"));
                            self.twoPhaseMethodConsole = enable;
                            self.appData.twoPhaseMethodConsole = enable;
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_cannot_edit_tenant_two_phase_method"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","setTwoPhaseMethodConsole").replace("{code}",res.data.status));
                            break;
                    }
                    self.showTwoPhaseMethodTenantEdit = false;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "setTwoPhaseMethod", error);
                    self.showTwoPhaseMethodTenantEdit = false;
                });
        },
        async setTwoPhaseMethodBoth(modifyTenantOptionRequest) {
            await this.setTwoPhaseMethod(modifyTenantOptionRequest);
            await this.setTwoPhaseMethodConsole(modifyTenantOptionRequest);
        },
    },
    components: {
        twoPhaseMethodSearch: TwoPhaseMethodSearch,
        twoPhaseMethodTenantEdit: TwoPhaseMethodTenantEdit,
        twoPhaseMethodTenantTOTP: TwoPhaseMethodTenantTOTP,
    },
    mounted: function() {
        this.dialogTitle = commonUtil.getMessageText(this.$i18n, "title_two_phase_auth_user_search");
    },
    created: function() {
        this.twoPhaseMethod = this.appData.twoPhaseMethod;
        this.twoPhaseMethodConsole = this.appData.twoPhaseMethodConsole;
    },
    watch: {
    },
    props: [ 'appData' ]
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.header-value {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #848991;
    font-size: 12px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.detailed-header {
    width: 95%;
    background-color: #f6f6f6;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 12px;
}
.detailed-table {
    width: 95%;
    margin-left: 20px;
}
.detailed-tr {
    border-bottom:1px #eee solid;
}
.detailed-left {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
}
.select-setting {
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
    width:35%;
    height:100%;
    valign:top
}
.vertical-line-addition {
    height: 100vh;
    margin: 0;
    padding: 0;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}
.code-guide-text {
     font-size: 16px;
     font-weight: 600;
     color: #5171cb;
 }

.search-form{
    padding-bottom: 10px;
}

::v-deep .el-dialog__header .el-dialog__title {
    vertical-align: middle;
    display: table-cell;
    font-size: 16px;
    font-weight: 700;
}

::v-deep .el-dialog__body {
  padding-top: 0;
  padding-bottom: 20px;
  padding-left: 20px;
}


</style>
